import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { MakeupBooking } from '~entities/makeup/api/book-makeup';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface RescheduleMakeupParams {
  makeupId: string;
  targetEnrollmentId: string;
  targetDate: string;
  notes?: string;
  sendConfirmation?: boolean;
  allowOverCapacity?: boolean;
}

export const rescheduleMakeupAPI = async (params: RescheduleMakeupParams) => {
  const { makeupId, ...body } = params;
  const response = await baseAPI.patch<MakeupBooking>(
    `/makeup/${makeupId}/reschedule`,
    body,
  );
  return response.data;
};

export const useRescheduleMakeupMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: rescheduleMakeupAPI,
    onSuccess: (booking) => {
      void queryClient.invalidateQueries({ queryKey: [KEYS.MAKEUP_BALANCES] });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.MAKEUP_BY_CLASS_DATE],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.MAKEUP_BY_SOURCE],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.MAKEUP_TARGETS],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.MAKEUP_OCCURRENCE_CAPACITY],
      });
      const studentId =
        typeof booking.studentId === 'string'
          ? booking.studentId
          : booking.studentId._id;
      void queryClient.invalidateQueries({
        queryKey: [KEYS.MAKEUP_BY_STUDENT, studentId],
      });
    },
  });
};
